import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import moment from "moment";

import { getLoggedProfile } from "../../actions/sessionAct";
import { getProfile } from "../../model/profile";
import { getUserCars, getUserReportReasons, reportUser } from "../../model/car";

import { LoadingPage } from "../common/loading";
import { commonErr } from "../common/errors";
import { MessagePage } from "../common/messagebox";
import { stypes, getDriverLicenseStatus, renderTimeCreated, renderNumberGreaterThan100 } from "../common/common";

import Header from "../components/header";
import Footer from "../components/footer";

import Login from "../login/login";
import SignUp from "../login/signup";
import ProfileReviews from "./profilereviews";

import { OwnerResponse, OwnerStarBox } from "./components/infoowner";

import avatar_default from "../../static/images/avatar_default.png";
import ProfileProperties from "./profileproperties";

import { ACCOUNT } from "../../constant/routes";
import { IcCheckS, IcInfoOrangeS, IcOwner5StarL, IcTotalTripM } from "../common/svg";

class UserReport extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			reasons: null,
			ip_reason: "",
			ip_comment: "",
		};
	}

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	reportUser = () => {
		if (
			this.state.ip_reason === "" ||
			this.state.ip_reason === "0" ||
			(this.state.ip_reason === "u0" && (!this.state.ip_comment || this.state.ip_comment === ""))
		) {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Vui lòng chọn lý do hoặc ghi rõ lý do của bạn.",
			});
		} else {
			reportUser(this.props.profile.uid, this.state.ip_reason, this.state.ip_comment).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS) {
					this.setState({
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
					this.props.hideModal();
				} else {
					this.setState({
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
				}
			});
		}
	};

	componentDidMount() {
		getUserReportReasons(this.props.profile.uid).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					reasons: resp.data.data.reasons,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	}

	render() {
		return (
			<Modal show={this.props.show} onHide={this.props.hideModal} dialogClassName="modal-sm modal-dialog">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Báo xấu tài khoản</h5>
				</Modal.Header>
				{this.state.err < commonErr.SUCCESS && this.state.errMsg !== "" && (
					<p className="textAlign-center" style={{ color: "red" }}>
						{this.state.errMsg}
					</p>
				)}
				<Modal.Body>
					<div className="form-default form-s">
						<div className="line-form">
							<div className="wrap-select">
								<select name="ip_reason" onChange={this.handleInputChange.bind(this)}>
									<option value="0" disabled selected>
										Chọn lý do
									</option>
									{this.state.reasons &&
										this.state.reasons.map((reason) => (
											<option key={reason.reason} value={reason.reason}>
												{reason.desc}
											</option>
										))}
								</select>
							</div>
						</div>
						<div className="line-form">
							<div className="wrap-input has-ico">
								<input
									type="text"
									placeholder="Lời nhắn"
									name="ip_comment"
									onChange={this.handleInputChange.bind(this)}
								/>
							</div>
						</div>
						<div className="clear" />
						<button
							className="btn btn-primary btn--m"
							type="button"
							name="cancelTripBtn"
							onClick={this.reportUser.bind(this)}>
							Báo xấu
						</button>
					</div>
				</Modal.Body>
			</Modal>
		);
	}
}

class Profile extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			data: null,
			reviewType: 1,
			stype: stypes.SD,
			showLoginForm: false,
			showReportForm: false,
			isOwner: false,
			isTrip: false,
			isReview: false,
			sdCars: [],
			wdCars: [],
			totalSDCars: 0,
			totalWDCars: 0,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);

		const items = JSON.parse(localStorage.getItem("info"));

		if (items !== null) {
			this.setState({
				isOwner: items.isOwner,
				isTrip: items.isTrip,
				isReview: items.isReview,
			});
		}

		getProfile(this.props.match.params.userId, "pd" /*view count for server*/).then((resp) => {
			this.setState({
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				data: resp.data.data,
			});
		});
		this.getCars();
	}

	getCars = () => {
		getUserCars(this.props.match.params.userId, 0, 0, 0, 0, true, stypes.SD).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					err: resp.data.error,
					sdCars: resp.data.data.cars,
					totalSDCars: resp.data.data.totalCars,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});

		getUserCars(this.props.match.params.userId, 0, 0, 0, 0, true, stypes.WD).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					wdCars: resp.data.data.cars,
					err: resp.data.error,
					totalWDCars: resp.data.data.totalCars,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	showLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	openSignupForm = () => {
		this.setState({
			showSignup: true,
		});
	};

	closeSignupForm = () => {
		this.setState({
			showSignup: false,
		});
	};

	showReportForm = () => {
		this.setState({
			showReportForm: true,
		});
	};

	closeReportForm = () => {
		this.setState({
			showReportForm: false,
		});
	};

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	reportUserBtnClick = () => {
		if (this.props.session.profile.info && this.props.session.profile.info.uid) {
			this.showReportForm();
		} else {
			this.showLoginForm();
		}
	};

	buildCOwner = () => {
		const { isOwner, isTrip, isReview, totalSDCars, totalWDCars, data } = this.state;
		const profile = data.profile;
		const totalTrip = profile.traveler.totalTrips + profile.owner.totalTrips;
		const hasCars = totalSDCars + totalWDCars > 0;
		const isDefaultOwner = !isTrip && !isOwner && !isReview && hasCars > 0;

		if (hasCars > 0) {
			if (isOwner || isReview || isDefaultOwner) {
				return (
					<div className="content-item user-profile">
						<div className="title">
							<div className="title-edit">
								<h5>Thông tin tài khoản</h5>
							</div>
							<div className="total-trips">
								<div className="wrap-svg">
									<IcTotalTripM />
								</div>
								<p className="count">{renderNumberGreaterThan100(totalTrip)}</p>
								<span>chuyến</span>
							</div>
						</div>
						<div className="content">
							<div className="avatar-box">
								<div className={`avatar avatar--xl`}>
									<img
										loading="lazy"
										src={profile.avatar && profile.avatar.fullUrl ? profile.avatar.fullUrl : avatar_default}
									/>
								</div>
								<h6>{profile.name}</h6>
								<p className="note">{renderTimeCreated(profile.timeCreated)}</p>
								<div className="trip-class">
									<div className="total-trips">
										<div className="wrap-svg">
											<IcTotalTripM />
										</div>
										<p className="count">{renderNumberGreaterThan100(totalTrip)}</p>
										<span>chuyến</span>
									</div>
								</div>
							</div>
							<div className="info-user center">
								<div className="info-note">
									<OwnerResponse owner={profile.owner} />
									{(profile.owner.ownerHostFiveStarSD > 0 || profile.owner.ownerHostFiveStarWD > 0) && <OwnerStarBox />}
								</div>
							</div>
						</div>
					</div>
				);
			}
			if (isTrip) {
				return (
					<div className="content-item user-profile">
						<div className="title">
							<div className="title-edit">
								<h5>Thông tin tài khoản</h5>
							</div>
							<div className="total-trips">
								<div className="wrap-svg">
									<IcTotalTripM />
								</div>
								<p className="count">{renderNumberGreaterThan100(totalTrip)}</p>
								<span>chuyến</span>
							</div>
						</div>
						<div className="content">
							<div className="avatar-box">
								<div className={`avatar avatar--xl`}>
									<img
										loading="lazy"
										src={profile.avatar && profile.avatar.fullUrl ? profile.avatar.fullUrl : avatar_default}
									/>
								</div>
								<h6>{profile.name}</h6>
								<p className="note">{renderTimeCreated(profile.timeCreated)}</p>
								<div className="trip-class">
									<div className="total-trips">
										<div className="wrap-svg">
											<IcTotalTripM />
										</div>
										<p className="count">{renderNumberGreaterThan100(totalTrip)}</p>
										<span>chuyến</span>
									</div>
								</div>
							</div>

							<div className="info-user center">
								<div className="info-note">
									<OwnerResponse owner={profile.owner} />
									{(profile.owner.ownerHostFiveStarSD > 0 || profile.owner.ownerHostFiveStarWD > 0) && <OwnerStarBox />}
								</div>
							</div>
						</div>
					</div>
				);
			}
		} else {
			if (isTrip) {
				return (
					<div className="content-item user-profile">
						<div className="title">
							<div className="title-edit">
								<h5>Thông tin tài khoản</h5>
							</div>
							<div className="total-trips">
								<div className="wrap-svg">
									<IcTotalTripM />
								</div>
								<p className="count">{renderNumberGreaterThan100(totalTrip)}</p>
								<span>chuyến</span>
							</div>
						</div>
						<div className="content">
							<div className="avatar-box width-100">
								<div className={`avatar avatar--xl`}>
									<img
										loading="lazy"
										src={profile.avatar && profile.avatar.fullUrl ? profile.avatar.fullUrl : avatar_default}
									/>
								</div>
								<h6>{profile.name}</h6>
								<p className="note">{renderTimeCreated(profile.timeCreated)}</p>
								<div className="trip-class">
									<div className="total-trips">
										<div className="wrap-svg">
											<IcTotalTripM />
										</div>
										<p className="count">{renderNumberGreaterThan100(totalTrip)}</p>
										<span>chuyến</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				);
			} else {
				return (
					<div className="content-item user-profile">
						<div className="title">
							<div className="title-edit">
								<h5>Thông tin tài khoản</h5>
							</div>
							<div className="total-trips">
								<div className="wrap-svg">
									<IcTotalTripM />
								</div>
								<p className="count">{renderNumberGreaterThan100(totalTrip)}</p>
								<span>chuyến</span>
							</div>
						</div>
						<div className="content">
							<div className="avatar-box width-100">
								<div className={`avatar avatar--xl`}>
									<img
										loading="lazy"
										src={profile.avatar && profile.avatar.fullUrl ? profile.avatar.fullUrl : avatar_default}
									/>
								</div>
								<h6>{profile.name}</h6>
								<p className="note">{renderTimeCreated(profile.timeCreated)}</p>
								<div className="trip-class">
									<div className="total-trips">
										<div className="wrap-svg">
											<IcTotalTripM />
										</div>
										<p className="count">{renderNumberGreaterThan100(totalTrip)}</p>
										<span>chuyến</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				);
			}
		}
	};

	render() {
		var content;
		const { err, data, reviewType, stype, showLoginForm, showReportForm, isOwner, isTrip, isReview } = this.state;

		if (err === commonErr.INNIT || err === commonErr.LOADING) {
			content = <LoadingPage />;
		} else if (err === commonErr.SUCCESS && this.props.match.params.userId === this.props.session.profile.info.uid) {
			return <Redirect to={ACCOUNT} />;
		} else if (err === commonErr.SUCCESS && data) {
			const profile = data.profile;

			const { totalSDCars, totalWDCars, sdCars, wdCars } = this.state;
			const hasCars = totalSDCars + totalWDCars > 0;

			content = (
				<section className="body">
					<div className="account-section sec space">
						<div className="m-container">
							<div className="account-container">
								<div className="content-account centered">
									{this.buildCOwner()}
									{hasCars > 0 && (
										<ProfileProperties
											sdCars={sdCars}
											wdCars={wdCars}
											totalSDCars={totalSDCars}
											totalWDCars={totalWDCars}
											stype={stype}
										/>
									)}
									<ProfileReviews profile={profile} reviewType={reviewType} />
								</div>
							</div>
						</div>
					</div>
					<Login
						show={this.state.showLoginForm}
						openSignupForm={this.openSignupForm}
						showModal={this.openLoginForm}
						hideModal={this.closeLoginForm}
						getLoggedProfile={this.getLoggedProfile}
					/>
					<SignUp
						show={this.state.showSignup}
						showModal={this.openSignupForm}
						hideModal={this.closeSignupForm}
						openLoginForm={this.openLoginForm}
						getLoggedProfile={this.getLoggedProfile}
					/>
					<UserReport show={showReportForm} hideModal={this.closeReportForm} profile={profile} />
				</section>
			);
		} else {
			content = <MessagePage message="Không tìm thấy thông tin." />;
		}

		return (
			<div className="mioto-layout">
				<Header />
				{content}
				<Footer />
			</div>
		);
	}
}

function mapSate(state) {
	return {
		session: state.session,
	};
}

Profile = connect(mapSate)(Profile);

export default Profile;
